import api from "../Hooks/axiosApi";


/* The fact find is filled in without a login, so its reads cannot rely on a session.
   A client id is a small sequential number and guessable on its own, so the API now
   also wants the client's own key - the FactFindClientGuid handed back when their
   record is created.

   It is held here rather than threaded through every form component: the read calls
   keep their existing signatures and pick it up on the way out. sessionStorage so it
   survives a refresh mid-wizard but does not outlive the tab.

   Signed in staff do not need it; the API accepts their token instead. */
const FF_TOKEN_KEY = "factFindClientGuid";

const readStoredToken = (): string | null => {
    try { return sessionStorage.getItem(FF_TOKEN_KEY); } catch { return null; }
};

let factFindToken: string | null = readStoredToken();

export const setFactFindToken = (guid?: string | null) => {
    factFindToken = guid || null;
    try {
        if (guid) sessionStorage.setItem(FF_TOKEN_KEY, guid);
        else sessionStorage.removeItem(FF_TOKEN_KEY);
    } catch { /* private browsing - the token still works for this page load */ }
};

export const getFactFindToken = () => factFindToken;

const withToken = (url: string) => {
    const t = factFindToken || readStoredToken();
    if (!t) return url;
    return `${url}${url.includes("?") ? "&" : "?"}token=${encodeURIComponent(t)}`;
};

export const getClientFactFindDLLService = () => {
    const response = api.get('/api/ClientFactFindPublic/GetClientFactFindDLL');
    return response;
};

export const insertUpdateClientService = async (data: any) => {
    const response = await api.post('/api/ClientFactFindPublic/InsertUpdateClient', data);
    // Capture the client's key the moment their record exists.
    const guid = response?.data?.factFindClientGuid ?? response?.data?.FactFindClientGuid;
    if (guid) setFactFindToken(String(guid));
    return response;
};

export const updateClientAssetsService = (data: any) => {
    const response = api.post(`/api/ClientFactFindPublic/UpdateClientAssets?clientId=${data.clientID}`, data);
    return response;
};

export const updateClientExpensesService = ({ formData, clientId }: { formData: any, clientId: string | number }) => {
    const response = api.post(`/api/ClientFactFindPublic/UpdateClientExpenses?clientId=${clientId}`, formData);
    return response;
};

export const sendFactFindPdfFileService = (data: any) => {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
            if (value instanceof File) {
                formData.append(key, value);
            } else {
                formData.append(key, String(value));
            }
        }
    });
    return api.post('/api/ClientFactFindPublic/sendemailwithfactfindpdf', formData);
};


// Add property api's service of assets property , assets not property and liabilites 

export const getClientLiabilitiesByIdService = (id: string | number |any) => {
    const response = api.get(`/api/ClientFactFindPublic/GetClientLiabilitiesById/${id}`);
    return response;
}

export const insertOrUpdateClientLiabilitiesService = (data: any) => {
    const response = api.post('/api/ClientFactFindPublic/InsertOrUpdateClientLiabilities', data);
    return response;
};

export const getAllClientLiabilitiesByClientIdService = (clientId: string | number) => {
    const response = api.get(withToken(`/api/ClientFactFindPublic/GetByAllClientLiabilitiesClientId/${clientId}`));
    return response;
};

export const softDeleteClientLiabilitiesService = (id: string | number) => {
    const response = api.delete(`/api/ClientFactFindPublic/SoftDeleteClientLiabilities/${id}`);
    return response;
};


export const insertOrUpdateAssetsPropertyService = (data: any) => {
    return api.post('/api/ClientFactFindPublic/InsertOrUpdateAssetsProperty', data);
};
export const insertOrUpdateAssetsInvPropertyService = (data: any) => {
    return api.post('/api/Property/UpsertInvestmentProperties', data);
};

export const getAssetsPropertyByIdService = (id: string | number | any) => {
    return api.get(`/api/ClientFactFindPublic/GetAssetsPropertyById/${id}`);
};
export const getAssetsInvPropertyByIdService = (id: string | number | any) => {
    return api.get(`/api/Property/GetInvestmentProperties/${id}`);
};

export const getAssetsPropertyByClientIdService = (clientId: string | number) => {
    return api.get(withToken(`/api/ClientFactFindPublic/GetAssetsPropertyByClientId/${clientId}`));
};

export const softDeleteAssetsPropertyService = (id: string | number) => {
    return api.delete(`/api/ClientFactFindPublic/SoftDeleteAssetsProperty/${id}`);
};


export const insertOrUpdateClientVehicleAssetsService = (data: any) => {
    return api.post('/api/ClientFactFindPublic/InsertOrUpdateClientVehicleAssets', data);
};

export const getClientVehicleAssetsByIdService = (id: string | number | any) => {
    return api.get(`/api/ClientFactFindPublic/GetClientVehicleAssetsById/${id}`);
};

export const getClientVehicleAssetsByClientIdService = (clientId: string | number) => {
    return api.get(withToken(`/api/ClientFactFindPublic/GetClientVehicleAssetsByClientId/${clientId}`));

};

export const softDeleteVehicleAssetsByIdService = (id: string | number) => {
    return api.delete(`/api/ClientFactFindPublic/SoftDeleteClientVehicleAssets/${id}`);
}